var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tsa d-inline ml-1"},[_c('i',{class:[
      { 'fa-caret-down': _vm.order == 'desc', 'fa-caret-up': _vm.order == 'asc', 'gray-arrow': ! _vm.isCurrent, 'black-arrow': _vm.isCurrent },
      'fa',
    ],on:{"click":function($event){return _vm.toggle()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }